import React, { useState, useEffect } from 'react';
import supabase from '../../lib/supabase'; // Assuming your supabase client is here
import { useAuth } from '../../contexts/AuthContext'; // Changed import to useAuth
import '../../styles/components/FeedbackModal.css'; // Assumes CSS was created

const FeedbackModal = ({ onClose }) => {
  const { user } = useAuth() || {}; // Changed to use useAuth hook
  const [email, setEmail] = useState('');
  const [feedbackType, setFeedbackType] = useState('General Comment');
  const [message, setMessage] = useState('');
  const [isHuman, setIsHuman] = useState(false);
  const [pageContext, setPageContext] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (user && user.email) {
      setEmail(user.email);
    }
    setPageContext(window.location.href);
  }, [user]);

  // Handle Escape key to close modal
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!user && !isHuman) {
      setError('Please confirm you are human.');
      return;
    }

    if (!message.trim()) {
      setError('Feedback message cannot be empty.');
      return;
    }

    setIsLoading(true);

    const feedbackData = {
      user_id: user ? user.id : null,
      email: email.trim() || null, // Store email if provided, even for logged-in users if they change it
      feedback_type: feedbackType,
      message: message.trim(),
      page_context: pageContext,
      status: 'Submitted', // Default status from your SQL schema
    };

    try {
      const { error: insertError } = await supabase
        .from('feedback')
        .insert([feedbackData]);

      if (insertError) {
        throw insertError;
      }

      setSuccessMessage('Thank you! Your feedback has been submitted.');
      setMessage('');
      setFeedbackType('General Comment');  // reset to default
      if (!user) setEmail('');
      setIsHuman(false); // Reset human check for anonymous users
      // Optionally close modal after a delay
      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (err) {
      setError(`Failed to submit feedback: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const feedbackTypes = [
    'Something isn\'t working',
    'I have an idea or suggestion',
    'General Comment',
    'I love it!',
    'Other',
  ];

  return (
    <div className="feedback-modal-overlay">
      <div className="feedback-modal">
        <button onClick={onClose} className="feedback-modal-close-btn" aria-label="Close feedback form">&times;</button>
        <h2>Submit Feedback</h2>
        {error && <p className="feedback-error">{error}</p>}
        {successMessage && <p className="feedback-success">{successMessage}</p>}
        {!successMessage && (
          <form onSubmit={handleSubmit}>
            {!user && (
              <div className="form-group">
                <label htmlFor="email">Your Email (Optional)</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                />
              </div>
            )}
            {user && user.email && (
                 <div className="form-group">
                    <label htmlFor="email">Email (from your account)</label>
                    <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)} // Allow editing if desired
                    readOnly={false} // Or true if you don't want them to change it
                    />
                </div>
            )}
            <div className="form-group">
              <label htmlFor="feedbackType">Feedback Type</label>
              <select
                id="feedbackType"
                value={feedbackType}
                onChange={(e) => setFeedbackType(e.target.value)}
              >
                {feedbackTypes.map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                required
                placeholder="Tell us what you think..."
              />
            </div>
            {!user && (
              <div className="form-group human-check">
                <input
                  type="checkbox"
                  id="isHuman"
                  checked={isHuman}
                  onChange={(e) => setIsHuman(e.target.checked)}
                />
                <label htmlFor="isHuman">I am human</label>
              </div>
            )}
            <div className="feedback-modal-actions">
              <button type="button" onClick={onClose} className="cancel-feedback-btn">
                Cancel
              </button>
              <button type="submit" className="submit-feedback-btn" disabled={isLoading}>
                {isLoading ? 'Submitting...' : 'Submit Feedback'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default FeedbackModal;
